export function Logomark({
  className,
  fill,
}: {
  className?: string;
  fill?: string;
}) {
  return (
    <svg
      width="51"
      height="50"
      viewBox="0 0 51 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1355 6.77148C14.0817 6.77148 7.55273 13.3004 7.55273 21.3543V28.6456C7.55273 36.6995 14.0817 43.2284 22.1355 43.2284H29.4269C37.4807 43.2284 44.0097 36.6995 44.0097 28.6457V21.3543C44.0097 13.3004 37.4807 6.77148 29.4269 6.77148H22.1355ZM23.5961 13.3338C18.3611 13.3338 14.1173 17.5776 14.1173 22.8126V27.1874C14.1173 32.4224 18.3611 36.6662 23.5961 36.6662H27.9709C33.2059 36.6662 37.4497 32.4224 37.4497 27.1874V22.8126C37.4497 17.5776 33.2059 13.3338 27.9709 13.3338H23.5961Z"
        fill={fill || "#F8F8F8"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.60938 0.0268555C8.25576 7.48311 14.5132 13.3335 22.1371 13.3335H29.4285C37.0524 13.3335 43.3098 7.48312 43.9562 0.0268555H37.3503C36.739 3.84991 33.4261 6.77114 29.4308 6.77114H22.1394C18.1441 6.77114 14.8311 3.84991 14.2199 0.0268555H7.60938Z"
        fill={fill || "#F8F8F8"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.9512 49.9727C43.3048 42.5164 37.0473 36.666 29.4235 36.666L22.1321 36.666C14.5082 36.666 8.25079 42.5164 7.60437 49.9727L14.2101 49.9727C14.8213 46.1496 18.1343 43.2283 22.1296 43.2283L29.421 43.2283C33.4163 43.2283 36.7293 46.1496 37.3406 49.9727L43.9512 49.9727Z"
        fill={fill || "#F8F8F8"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.806641 43.1733C8.26202 42.5261 14.1115 36.269 14.1115 28.6458L14.1115 21.3544C14.1115 13.7311 8.26202 7.47411 0.806639 6.82684L0.806639 13.4347C4.63 14.0457 7.55154 17.3589 7.55154 21.3544L7.55154 28.6457C7.55154 32.6412 4.63 35.9544 0.80664 36.5654L0.806641 43.1733Z"
        fill={fill || "#F8F8F8"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.752 6.82666C43.2962 7.47354 37.4463 13.7308 37.4463 21.3543L37.4463 28.6457C37.4463 36.2692 43.2962 42.5264 50.752 43.1733L50.752 36.5654C46.9282 35.9547 44.0063 32.6414 44.0063 28.6457L44.0063 21.3543C44.0063 17.3585 46.9282 14.0452 50.752 13.4345L50.752 6.82666Z"
        fill={fill || "#F8F8F8"}
      />
    </svg>
  );
}

export function Logo({
  className,
  fill,
}: {
  className?: string;
  fill?: string;
}) {
  return (
    <svg
      width="237"
      height="69"
      viewBox="0 0 237 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1336 16.3311C14.0797 16.3311 7.55078 22.86 7.55078 30.9138V38.2052C7.55078 46.2591 14.0797 52.788 22.1336 52.788H29.4249C37.4788 52.788 44.0077 46.2591 44.0077 38.2052V30.9138C44.0077 22.86 37.4788 16.3311 29.4249 16.3311H22.1336ZM23.5941 22.8933C18.3591 22.8933 14.1153 27.1371 14.1153 32.3722V36.747C14.1153 41.982 18.3591 46.2258 23.5941 46.2258H27.969C33.204 46.2258 37.4478 41.982 37.4478 36.747V32.3722C37.4478 27.1372 33.204 22.8933 27.969 22.8933H23.5941Z"
        fill={fill || "#F8F8F8"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.60938 9.58643C8.25576 17.0427 14.5132 22.8931 22.1371 22.8931H29.4285C37.0524 22.8931 43.3098 17.0427 43.9562 9.58643H37.3503C36.739 13.4095 33.4261 16.3307 29.4308 16.3307H22.1394C18.1441 16.3307 14.8311 13.4095 14.2199 9.58643H7.60938Z"
        fill={fill || "#F8F8F8"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.9492 59.5322C43.3028 52.076 37.0454 46.2256 29.4215 46.2256L22.1301 46.2256C14.5063 46.2256 8.24883 52.076 7.60241 59.5322L14.2081 59.5322C14.8194 55.7091 18.1324 52.7879 22.1277 52.7879L29.4191 52.7879C33.4144 52.7879 36.7273 55.7091 37.3386 59.5322L43.9492 59.5322Z"
        fill={fill || "#F8F8F8"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.804688 52.7329C8.26006 52.0856 14.1095 45.8286 14.1095 38.2054L14.1095 30.914C14.1095 23.2907 8.26006 17.0337 0.804686 16.3864L0.804686 22.9943C4.62804 23.6053 7.54959 26.9184 7.54959 30.9139L7.54959 38.2053C7.54959 42.2008 4.62804 45.5139 0.804687 46.125L0.804688 52.7329Z"
        fill={fill || "#F8F8F8"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.75 16.3862C43.2942 17.0331 37.4444 23.2903 37.4444 30.9139L37.4444 38.2052C37.4443 45.8288 43.2942 52.086 50.75 52.7329L50.75 46.125C46.9263 45.5143 44.0043 42.201 44.0043 38.2052L44.0043 30.9138C44.0043 26.9181 46.9263 23.6048 50.75 22.9941L50.75 16.3862Z"
        fill={fill || "#F8F8F8"}
      />
      <path
        d="M77.926 16.9296V47.6467H93.2595V53.5596H71.512V16.9296H77.926ZM114.36 28.8055H120.473V53.5596H114.811L114.36 50.2523C112.857 52.6075 109.65 54.211 106.342 54.211C100.63 54.211 97.2725 50.3526 97.2725 44.2893V28.8055H103.386V42.1346C103.386 46.8449 105.24 48.7491 108.647 48.7491C112.506 48.7491 114.36 46.4941 114.36 41.7839V28.8055ZM124.845 41.1324C124.845 33.4657 129.906 28.0539 137.222 28.0539C143.987 28.0539 148.597 31.8121 149.248 37.7751H143.135C142.433 34.969 140.379 33.5158 137.472 33.5158C133.564 33.5158 130.958 36.4722 130.958 41.1324C130.958 45.7926 133.363 48.699 137.272 48.699C140.329 48.699 142.483 47.1957 143.135 44.4898H149.298C148.547 50.2523 143.736 54.211 137.272 54.211C129.756 54.211 124.845 48.9996 124.845 41.1324ZM160.012 53.5596H153.949V16.2781H160.012V39.1782L169.633 28.8055H177.3L167.879 38.627L177.099 53.5596H170.084L163.62 43.1368L160.012 46.895V53.5596ZM178.657 65.0346V59.9235H182.315C184.72 59.9235 186.223 59.3723 187.276 56.4659L187.977 54.6119L178.006 28.8055H184.47L190.834 46.8449L197.548 28.8055H203.862L191.736 59.0716C189.881 63.6817 187.276 65.5858 183.217 65.5858C181.513 65.5858 180.01 65.3854 178.657 65.0346ZM206.282 43.1869C206.282 38.8274 208.737 35.3197 212.546 33.8666C209.339 32.4134 207.585 29.6574 207.585 26.0996C207.585 20.2869 212.746 16.2781 220.313 16.2781C227.829 16.2781 232.89 20.2368 232.89 26.1998C232.89 29.7576 231.086 32.5136 227.829 33.8666C231.688 35.2195 234.193 38.7773 234.193 43.1869C234.193 49.8014 228.731 54.1609 220.213 54.1609C211.744 54.1609 206.282 49.8515 206.282 43.1869ZM213.398 26.6508C213.398 29.7075 216.053 31.6617 220.213 31.6617C224.322 31.6617 226.927 29.7576 226.927 26.7009C226.927 23.6442 224.322 21.7401 220.213 21.7401C216.053 21.7401 213.398 23.6442 213.398 26.6508ZM212.546 42.7359C212.546 46.2937 215.502 48.4985 220.263 48.4985C224.923 48.4985 227.879 46.2937 227.879 42.7359C227.879 39.1782 224.923 36.9733 220.213 36.9733C215.502 36.9733 212.546 39.1782 212.546 42.7359Z"
        fill={fill || "#F8F8F8"}
      />
    </svg>
  );
}

export function USDCLogo({ className }: { className?: string }) {
  return (
    <svg
      data-name="86977684-12db-4850-8f30-233a7c267d11"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      className={className}
    >
      <path
        d="M1000 2000c554.17 0 1000-445.83 1000-1000S1554.17 0 1000 0 0 445.83 0 1000s445.83 1000 1000 1000z"
        fill="#2775ca"
      />
      <path
        d="M1275 1158.33c0-145.83-87.5-195.83-262.5-216.66-125-16.67-150-50-150-108.34s41.67-95.83 125-95.83c75 0 116.67 25 137.5 87.5 4.17 12.5 16.67 20.83 29.17 20.83h66.66c16.67 0 29.17-12.5 29.17-29.16v-4.17c-16.67-91.67-91.67-162.5-187.5-170.83v-100c0-16.67-12.5-29.17-33.33-33.34h-62.5c-16.67 0-29.17 12.5-33.34 33.34v95.83c-125 16.67-204.16 100-204.16 204.17 0 137.5 83.33 191.66 258.33 212.5 116.67 20.83 154.17 45.83 154.17 112.5s-58.34 112.5-137.5 112.5c-108.34 0-145.84-45.84-158.34-108.34-4.16-16.66-16.66-25-29.16-25h-70.84c-16.66 0-29.16 12.5-29.16 29.17v4.17c16.66 104.16 83.33 179.16 220.83 200v100c0 16.66 12.5 29.16 33.33 33.33h62.5c16.67 0 29.17-12.5 33.34-33.33v-100c125-20.84 208.33-108.34 208.33-220.84z"
        fill="#fff"
      />
      <path
        d="M787.5 1595.83c-325-116.66-491.67-479.16-370.83-800 62.5-175 200-308.33 370.83-370.83 16.67-8.33 25-20.83 25-41.67V325c0-16.67-8.33-29.17-25-33.33-4.17 0-12.5 0-16.67 4.16-395.83 125-612.5 545.84-487.5 941.67 75 233.33 254.17 412.5 487.5 487.5 16.67 8.33 33.34 0 37.5-16.67 4.17-4.16 4.17-8.33 4.17-16.66v-58.34c0-12.5-12.5-29.16-25-37.5zM1229.17 295.83c-16.67-8.33-33.34 0-37.5 16.67-4.17 4.17-4.17 8.33-4.17 16.67v58.33c0 16.67 12.5 33.33 25 41.67 325 116.66 491.67 479.16 370.83 800-62.5 175-200 308.33-370.83 370.83-16.67 8.33-25 20.83-25 41.67V1700c0 16.67 8.33 29.17 25 33.33 4.17 0 12.5 0 16.67-4.16 395.83-125 612.5-545.84 487.5-941.67-75-237.5-258.34-416.67-487.5-491.67z"
        fill="#fff"
      />
    </svg>
  );
}

export function UniswapLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 168.3 193.8"
      className={className}
    >
      <style>
        {`.st0,.st1{fill:#ff007a}.st1{fill-rule:evenodd;clip-rule:evenodd}`}
      </style>
      <path
        d="M66 44.1c-2.1-.3-2.2-.4-1.2-.5 1.9-.3 6.3.1 9.4.8 7.2 1.7 13.7 6.1 20.6 13.8l1.8 2.1 2.6-.4c11.1-1.8 22.5-.4 32 4 2.6 1.2 6.7 3.6 7.2 4.2.2.2.5 1.5.7 2.8.7 4.7.4 8.2-1.1 10.9-.8 1.5-.8 1.9-.3 3.2.4 1 1.6 1.7 2.7 1.7 2.4 0 4.9-3.8 6.1-9.1l.5-2.1.9 1c5.1 5.7 9.1 13.6 9.7 19.2l.2 1.5-.9-1.3c-1.5-2.3-2.9-3.8-4.8-5.1-3.4-2.3-7-3-16.5-3.5-8.6-.5-13.5-1.2-18.3-2.8-8.2-2.7-12.4-6.2-22.1-19.1-4.3-5.7-7-8.8-9.7-11.4-5.9-5.7-11.8-8.7-19.5-9.9z"
        className="st0"
      />
      <path
        d="M140.5 56.8c.2-3.8.7-6.3 1.8-8.6.4-.9.8-1.7.9-1.7.1 0-.1.7-.4 1.5-.8 2.2-.9 5.3-.4 8.8.7 4.5 1 5.1 5.8 10 2.2 2.3 4.8 5.2 5.8 6.4l1.7 2.2-1.7-1.6c-2.1-2-6.9-5.8-8-6.3-.7-.4-.8-.4-1.3.1-.4.4-.5 1-.5 3.9-.1 4.5-.7 7.3-2.2 10.2-.8 1.5-.9 1.2-.2-.5.5-1.3.6-1.9.6-6.2 0-8.7-1-10.8-7.1-14.3-1.5-.9-4.1-2.2-5.6-2.9-1.6-.7-2.8-1.3-2.7-1.3.2-.2 6.1 1.5 8.4 2.5 3.5 1.4 4.1 1.5 4.5 1.4.3-.3.5-1.1.6-3.6zM70.1 71.7c-4.2-5.8-6.9-14.8-6.3-21.5l.2-2.1 1 .2c1.8.3 4.9 1.5 6.4 2.4 4 2.4 5.8 5.7 7.5 13.9.5 2.4 1.2 5.2 1.5 6.1.5 1.5 2.4 5 4 7.2 1.1 1.6.4 2.4-2.1 2.2-3.8-.4-8.9-3.9-12.2-8.4zM135.4 115.2c-19.8-8-26.8-14.9-26.8-26.6 0-1.7.1-3.1.1-3.1.1 0 .8.6 1.7 1.3 4 3.2 8.5 4.6 21 6.4 7.3 1.1 11.5 1.9 15.3 3.2 12.1 4 19.6 12.2 21.4 23.3.5 3.2.2 9.3-.6 12.5-.7 2.5-2.7 7.1-3.2 7.2-.1 0-.3-.5-.3-1.3-.2-4.2-2.3-8.2-5.8-11.3-4.2-3.6-9.6-6.3-22.8-11.6zM121.4 118.5c-.2-1.5-.7-3.4-1-4.2l-.5-1.5.9 1.1c1.3 1.5 2.3 3.3 3.2 5.8.7 1.9.7 2.5.7 5.6 0 3-.1 3.7-.7 5.4-1 2.7-2.2 4.6-4.2 6.7-3.6 3.7-8.3 5.7-15 6.6-1.2.1-4.6.4-7.6.6-7.5.4-12.5 1.2-17 2.8-.6.2-1.2.4-1.3.3-.2-.2 2.9-2 5.4-3.2 3.5-1.7 7.1-2.6 15-4 3.9-.6 7.9-1.4 8.9-1.8 9.9-3.1 14.8-10.8 13.2-20.2z"
        className="st0"
      />
      <path
        d="M130.5 134.6c-2.6-5.7-3.2-11.1-1.8-16.2.2-.5.4-1 .6-1 .2 0 .8.3 1.4.7 1.2.8 3.7 2.2 10.1 5.7 8.1 4.4 12.7 7.8 15.9 11.7 2.8 3.4 4.5 7.3 5.3 12.1.5 2.7.2 9.2-.5 11.9-2.2 8.5-7.2 15.3-14.5 19.2-1.1.6-2 1-2.1 1-.1 0 .3-1 .9-2.2 2.4-5.1 2.7-10 .9-15.5-1.1-3.4-3.4-7.5-8-14.4-5.5-8-6.8-10.1-8.2-13zM56 165.2c7.4-6.2 16.5-10.6 24.9-12 3.6-.6 9.6-.4 12.9.5 5.3 1.4 10.1 4.4 12.6 8.1 2.4 3.6 3.5 6.7 4.6 13.6.4 2.7.9 5.5 1 6.1.8 3.6 2.4 6.4 4.4 7.9 3.1 2.3 8.5 2.4 13.8.4.9-.3 1.7-.6 1.7-.5.2.2-2.5 2-4.3 2.9-2.5 1.3-4.5 1.7-7.2 1.7-4.8 0-8.9-2.5-12.2-7.5-.7-1-2.1-3.9-3.3-6.6-3.5-8.1-5.3-10.5-9.4-13.2-3.6-2.3-8.2-2.8-11.7-1.1-4.6 2.2-5.8 8.1-2.6 11.7 1.3 1.5 3.7 2.7 5.7 3 3.7.5 6.9-2.4 6.9-6.1 0-2.4-.9-3.8-3.3-4.9-3.2-1.4-6.7.2-6.6 3.3 0 1.3.6 2.1 1.9 2.7.8.4.8.4.2.3-2.9-.6-3.6-4.2-1.3-6.5 2.8-2.8 8.7-1.6 10.7 2.3.8 1.6.9 4.8.2 6.8-1.7 4.4-6.5 6.7-11.4 5.4-3.3-.9-4.7-1.8-8.7-5.9-7-7.2-9.7-8.6-19.7-10.1l-1.9-.3 2.1-2z"
        className="st0"
      />
      <path
        d="M3.4 4.3c23.3 28.3 59.2 72.3 61 74.7 1.5 2 .9 3.9-1.6 5.3-1.4.8-4.3 1.6-5.7 1.6-1.6 0-3.5-.8-4.8-2.1-.9-.9-4.8-6.6-13.6-20.3C32 53 26.3 44.3 26.2 44.2c-.4-.2-.4-.2 11.8 21.6C45.7 79.5 48.2 84.4 48.2 85c0 1.3-.4 2-2 3.8-2.7 3-3.9 6.4-4.8 13.5-1 7.9-3.7 13.5-11.4 23-4.5 5.6-5.2 6.6-6.3 8.9-1.4 2.8-1.8 4.4-2 8-.2 3.8.2 6.2 1.3 9.8 1 3.2 2.1 5.3 4.8 9.4 2.3 3.6 3.7 6.3 3.7 7.3 0 .8.2.8 3.8 0 8.6-2 15.7-5.4 19.6-9.6 2.4-2.6 3-4 3-7.6 0-2.3-.1-2.8-.7-4.2-1-2.2-2.9-4-7-6.8-5.4-3.7-7.7-6.7-8.3-10.7-.5-3.4.1-5.7 3.1-12 3.1-6.5 3.9-9.2 4.4-15.8.3-4.2.8-5.9 2-7.2 1.3-1.4 2.4-1.9 5.5-2.3 5.1-.7 8.4-2 11-4.5 2.3-2.1 3.3-4.2 3.4-7.3l.1-2.3-1.3-1.4C65.4 71.6.3 0 0 0c-.1 0 1.5 1.9 3.4 4.3zm30.7 142.2c1.1-1.9.5-4.3-1.3-5.5-1.7-1.1-4.3-.6-4.3.9 0 .4.2.8.8 1 .9.5 1 1 .3 2.1s-.7 2.1.2 2.8c1.4 1.1 3.3.5 4.3-1.3zM74.6 93.9c-2.4.7-4.7 3.3-5.4 5.9-.4 1.6-.2 4.5.5 5.4 1.1 1.4 2.1 1.8 4.9 1.8 5.5 0 10.2-2.4 10.7-5.3.5-2.4-1.6-5.7-4.5-7.2-1.5-.8-4.6-1.1-6.2-.6zm6.4 5c.8-1.2.5-2.5-1-3.4-2.7-1.7-6.8-.3-6.8 2.3 0 1.3 2.1 2.7 4.1 2.7 1.3 0 3.1-.8 3.7-1.6z"
        className="st1"
      />
    </svg>
  );
}

export const Layers = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="ml-1"
    >
      <g clipPath="url(#clip0_404_10045)">
        <path
          d="M6.99417 10.8153L2.695 7.47283L1.75 8.20783L7 12.2912L12.25 8.20783L11.2992 7.46699L6.99417 10.8153ZM7 9.33366L11.2933 5.99116L12.25 5.25033L7 1.16699L1.75 5.25033L2.70083 5.99116L7 9.33366ZM7 2.64283L10.3483 5.25033L7 7.85783L3.65167 5.25033L7 2.64283Z"
          fill="#F8F8F8"
        />
      </g>
      <defs>
        <clipPath id="clip0_404_10045">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NorthEast = ({ color }: { color?: string }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`ml-1`}
    >
      <g clipPath="url(#clip0_397_2732)">
        <path
          d="M6.0013 4.0835V5.41683H10.3946L2.66797 13.1435L3.60797 14.0835L11.3346 6.35683V10.7502H12.668V4.0835H6.0013Z"
          fill={color || "white"}
        />
      </g>
      <defs>
        <clipPath id="clip0_397_2732">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EtherscanLogo = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_404_10024)">
        <path
          d="M2.51615 5.69887C2.51616 5.63261 2.52926 5.56701 2.55469 5.50582C2.58013 5.44464 2.61739 5.38909 2.66436 5.34234C2.71134 5.2956 2.76706 5.2586 2.82837 5.23346C2.88968 5.20832 2.95535 5.19553 3.02161 5.19585L3.85966 5.19858C3.99327 5.19858 4.12141 5.25166 4.21589 5.34614C4.31038 5.44062 4.36346 5.56876 4.36346 5.70238V8.87116C4.4578 8.84316 4.57897 8.81331 4.71156 8.78209C4.80366 8.76046 4.88574 8.70834 4.94449 8.63419C5.00323 8.56003 5.03519 8.46821 5.03517 8.3736V4.44287C5.03517 4.30924 5.08824 4.18109 5.18272 4.08659C5.2772 3.99209 5.40535 3.939 5.53897 3.93897H6.37868C6.5123 3.939 6.64045 3.99209 6.73493 4.08659C6.8294 4.18109 6.88249 4.30924 6.88249 4.44287V8.09097C6.88249 8.09097 7.09273 8.0059 7.29751 7.91946C7.37358 7.88729 7.4385 7.83343 7.48416 7.7646C7.52983 7.69578 7.55421 7.61503 7.55429 7.53243V3.18336C7.55429 3.04976 7.60736 2.92162 7.70181 2.82714C7.79627 2.73267 7.92439 2.67958 8.05799 2.67955H8.89771C9.03133 2.67955 9.15946 2.73263 9.25395 2.82712C9.34843 2.92159 9.40151 3.04974 9.40151 3.18336V6.76472C10.1295 6.23711 10.8673 5.60258 11.4527 4.83955C11.5377 4.7288 11.5939 4.59874 11.6163 4.461C11.6388 4.32325 11.6268 4.18208 11.5814 4.05009C11.3104 3.27036 10.8797 2.55579 10.3166 1.9521C9.75361 1.34842 9.07077 0.868915 8.3118 0.544278C7.55284 0.219642 6.73446 0.0570217 5.90903 0.0668245C5.08361 0.0766271 4.26933 0.258638 3.51829 0.601206C2.76725 0.943776 2.09599 1.43936 1.54747 2.05625C0.998955 2.67313 0.585259 3.39773 0.332858 4.18368C0.0804581 4.96962 -0.00508881 5.7996 0.0816917 6.62051C0.168472 7.44142 0.42567 8.23516 0.836824 8.95097C0.908449 9.07444 1.01382 9.17492 1.14056 9.24059C1.26731 9.30626 1.41016 9.33439 1.55234 9.3217C1.71117 9.30775 1.90893 9.28794 2.14405 9.26033C2.2464 9.24872 2.3409 9.19985 2.40953 9.12304C2.47817 9.04623 2.51616 8.94685 2.51624 8.84385L2.51615 5.69887Z"
          fill="#A5A5A5"
        />
        <path
          d="M2.49805 10.7813C3.38315 11.4252 4.42915 11.8117 5.5203 11.8981C6.61146 11.9843 7.70523 11.7671 8.68058 11.2703C9.65594 10.7736 10.4748 10.0167 11.0467 9.0834C11.6185 8.1501 11.9211 7.07679 11.9208 5.98222C11.9208 5.84564 11.9144 5.71051 11.9054 5.57617C9.73765 8.80915 5.73522 10.3206 2.49823 10.7808"
          fill="#A5A5A5"
        />
      </g>
      <defs>
        <clipPath id="clip0_404_10024">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Settings = () => {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 ml-1"
    >
      <g clipPath="url(#clip0_397_2884)">
        <path
          d="M11.3338 7.5715C11.3572 7.38484 11.3747 7.19817 11.3747 6.99984C11.3747 6.8015 11.3572 6.61484 11.3338 6.42817L12.5647 5.46567C12.6755 5.37817 12.7047 5.22067 12.6347 5.09234L11.468 3.074C11.4155 2.98067 11.3163 2.92817 11.2113 2.92817C11.1763 2.92817 11.1413 2.934 11.1122 2.94567L9.65966 3.529C9.35633 3.29567 9.02966 3.10317 8.67383 2.95734L8.45216 1.4115C8.43466 1.2715 8.31216 1.1665 8.16633 1.1665H5.833C5.68716 1.1665 5.56466 1.2715 5.54716 1.4115L5.3255 2.95734C4.96966 3.10317 4.643 3.3015 4.33966 3.529L2.88716 2.94567C2.85216 2.934 2.81716 2.92817 2.78216 2.92817C2.683 2.92817 2.58383 2.98067 2.53133 3.074L1.36466 5.09234C1.28883 5.22067 1.32383 5.37817 1.43466 5.46567L2.6655 6.42817C2.64216 6.61484 2.62466 6.80734 2.62466 6.99984C2.62466 7.19234 2.64216 7.38484 2.6655 7.5715L1.43466 8.534C1.32383 8.6215 1.29466 8.779 1.36466 8.90734L2.53133 10.9257C2.58383 11.019 2.683 11.0715 2.788 11.0715C2.823 11.0715 2.858 11.0657 2.88716 11.054L4.33966 10.4707C4.643 10.704 4.96966 10.8965 5.3255 11.0423L5.54716 12.5882C5.56466 12.7282 5.68716 12.8332 5.833 12.8332H8.16633C8.31216 12.8332 8.43466 12.7282 8.45216 12.5882L8.67383 11.0423C9.02966 10.8965 9.35633 10.6982 9.65966 10.4707L11.1122 11.054C11.1472 11.0657 11.1822 11.0715 11.2172 11.0715C11.3163 11.0715 11.4155 11.019 11.468 10.9257L12.6347 8.90734C12.7047 8.779 12.6755 8.6215 12.5647 8.534L11.3338 7.5715ZM10.1788 6.574C10.2022 6.75484 10.208 6.87734 10.208 6.99984C10.208 7.12234 10.1963 7.25067 10.1788 7.42567L10.0972 8.08484L10.6163 8.49317L11.2463 8.98317L10.838 9.689L10.0972 9.3915L9.4905 9.1465L8.9655 9.54317C8.71466 9.72984 8.4755 9.86984 8.23633 9.969L7.618 10.2198L7.52466 10.879L7.408 11.6665H6.59133L6.4805 10.879L6.38716 10.2198L5.76883 9.969C5.518 9.864 5.28466 9.72984 5.05133 9.55484L4.5205 9.1465L3.90216 9.39734L3.16133 9.69484L2.753 8.989L3.383 8.499L3.90216 8.09067L3.8205 7.4315C3.803 7.25067 3.79133 7.1165 3.79133 6.99984C3.79133 6.88317 3.803 6.749 3.8205 6.574L3.90216 5.91484L3.383 5.5065L2.753 5.0165L3.16133 4.31067L3.90216 4.60817L4.50883 4.85317L5.03383 4.4565C5.28466 4.26984 5.52383 4.12984 5.763 4.03067L6.38133 3.77984L6.47466 3.12067L6.59133 2.33317H7.40216L7.513 3.12067L7.60633 3.77984L8.22466 4.03067C8.4755 4.13567 8.70883 4.26984 8.94216 4.44484L9.473 4.85317L10.0913 4.60234L10.8322 4.30484L11.2405 5.01067L10.6163 5.5065L10.0972 5.91484L10.1788 6.574ZM6.99966 4.6665C5.7105 4.6665 4.66633 5.71067 4.66633 6.99984C4.66633 8.289 5.7105 9.33317 6.99966 9.33317C8.28883 9.33317 9.333 8.289 9.333 6.99984C9.333 5.71067 8.28883 4.6665 6.99966 4.6665ZM6.99966 8.1665C6.358 8.1665 5.833 7.6415 5.833 6.99984C5.833 6.35817 6.358 5.83317 6.99966 5.83317C7.64133 5.83317 8.16633 6.35817 8.16633 6.99984C8.16633 7.6415 7.64133 8.1665 6.99966 8.1665Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_397_2884">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <g clipPath="url(#clip0_397_2888)">
        <path
          d="M11.334 4.6665H8.66732V5.99984H11.334C12.434 5.99984 13.334 6.89984 13.334 7.99984C13.334 9.09984 12.434 9.99984 11.334 9.99984H8.66732V11.3332H11.334C13.174 11.3332 14.6673 9.83984 14.6673 7.99984C14.6673 6.15984 13.174 4.6665 11.334 4.6665ZM7.33398 9.99984H4.66732C3.56732 9.99984 2.66732 9.09984 2.66732 7.99984C2.66732 6.89984 3.56732 5.99984 4.66732 5.99984H7.33398V4.6665H4.66732C2.82732 4.6665 1.33398 6.15984 1.33398 7.99984C1.33398 9.83984 2.82732 11.3332 4.66732 11.3332H7.33398V9.99984ZM5.33398 7.33317H10.6673V8.6665H5.33398V7.33317Z"
          fill="#363636"
        />
      </g>
      <defs>
        <clipPath id="clip0_397_2888">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DoubleUp = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mr-1 h-8 w-8"
    >
      <g clipPath="url(#clip0_397_2846)">
        <path
          d="M3.75 6.64111L3.75 10.1567L9 6.25049L14.25 10.1567L14.25 6.64111L9 2.73486L3.75 6.64111Z"
          fill="#F0CA4A"
        />
        <path
          d="M3.75 12.1094L3.75 15.625L9 11.7188L14.25 15.625L14.25 12.1094L9 8.20313L3.75 12.1094Z"
          fill="#F0CA4A"
        />
      </g>
      <defs>
        <clipPath id="clip0_397_2846">
          <rect
            width="18.75"
            height="18"
            fill="white"
            transform="translate(0 18.75) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Clock = () => {
  return (
    <svg
      className=""
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.995 0C2.235 0 0 2.24 0 5C0 7.76 2.235 10 4.995 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 4.995 0ZM5 9C2.79 9 1 7.21 1 5C1 2.79 2.79 1 5 1C7.21 1 9 2.79 9 5C9 7.21 7.21 9 5 9ZM5.25 2.5H4.5V5.5L7.125 7.075L7.5 6.46L5.25 5.125V2.5Z"
        fill="#F8F8F8"
      />
    </svg>
  );
};
